import React, { useState } from "react";
// NavLink'i ekledik: Sayfanın aktif olup olmadığını anlamamızı sağlar
import { BrowserRouter as Router, Routes, Route, Link, NavLink } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

// --- DOSYA İMPORTLARI (Senin dosya yapına göre) ---
import Home from "./pages/Home";
import PlayerMarket from "./pages/PlayerMarket";
import Goller from "./pages/Goller";
import Hakkimizda from "./pages/Hakkimizda";
import Reservation from "./pages/Reservation";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import SuperAdmin from "./pages/SuperAdmin";
import Profile from "./pages/Profile";
import PublicProfile from "./pages/PublicProfile";
import ComingSoon from "./pages/ComingSoon";
import PaymentStatus from "./pages/PaymentStatus";
import SquadBuilder from "./pages/SquadBuilder";
import LiveStream from "./pages/LiveStream";
import MatchArchives from "./pages/MatchArchives";
import Logo from "./components/Logo";
import UserSearchModal from "./components/UserSearchModal";
import NotificationBell from "./components/NotificationBell";
import { useAuth } from "./context/AuthContext";
import { SOCIAL_ENABLED } from "./config";
import Giris from "./pages/Giris";
import Kayit from "./pages/Kayit";

function App() {
  const isHideNavbar = window.location.pathname.startsWith('/superadmin') || window.location.pathname.startsWith('/admin-dashboard');
  const { currentUser, dbUser } = useAuth();
  const [showSearch, setShowSearch] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <Router>
      <div className="App">
        {/* --- SAYFAYA GÖRE NAVBAR GÖSTER/GİZLE --- */}
        {!isHideNavbar && (
          <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm">
            <div className="container-fluid">
              <Link className="navbar-brand d-flex align-items-center" to="/" style={{ whiteSpace: 'nowrap' }} onClick={() => setIsMenuOpen(false)}>
                <Logo width="220px" />
              </Link>
              <button className="navbar-toggler" type="button" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                <span className="navbar-toggler-icon"></span>
              </button>
              <div className={`collapse navbar-collapse ${isMenuOpen ? "show" : ""}`} id="navbarNav">
                <ul className="navbar-nav ms-auto mb-2 mb-lg-0 align-items-center">
                  <li className="nav-item">
                    <NavLink to="/" className={({ isActive }) => `nav-link px-3 custom-nav-link ${isActive ? "active-link fw-bold" : "text-secondary"}`} onClick={() => setIsMenuOpen(false)}>Ana Sayfa</NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to="/market" className={({ isActive }) => `nav-link px-3 custom-nav-link ${isActive ? "active-link fw-bold" : "text-secondary"}`} onClick={() => setIsMenuOpen(false)}>Saha Yıldızları</NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to="/goals" className={({ isActive }) => `nav-link px-3 custom-nav-link ${isActive ? "active-link fw-bold" : "text-secondary"}`} onClick={() => setIsMenuOpen(false)}>Goller</NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to="/about" className={({ isActive }) => `nav-link px-3 custom-nav-link ${isActive ? "active-link fw-bold" : "text-secondary"}`} onClick={() => setIsMenuOpen(false)}>Hakkımızda</NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to="/reservation" className={({ isActive }) => `nav-link px-3 custom-nav-link ${isActive ? "active-link fw-bold" : "text-secondary"}`} onClick={() => setIsMenuOpen(false)}>Rezervasyon Yap</NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to="/squad-builder" className={({ isActive }) => `nav-link px-3 custom-nav-link ${isActive ? "active-link fw-bold" : "text-secondary"}`} onClick={() => setIsMenuOpen(false)}>Kadro Kur</NavLink>
                  </li>
                </ul>
                <div className="d-flex ms-3 align-items-center gap-2">
                  {SOCIAL_ENABLED && (
                    <button className="btn btn-light rounded-circle border shadow-sm p-2 d-flex align-items-center justify-content-center me-1" style={{ width: "40px", height: "40px" }} onClick={() => { setShowSearch(true); setIsMenuOpen(false); }}>
                      <i className="fas fa-search text-dark"></i>
                    </button>
                  )}

                  {/* Tesis Girişi - Her zaman görünür */}
                  <Link className="btn btn-outline-dark rounded-pill px-3 fw-bold btn-sm shadow-sm" to="/giris" onClick={() => setIsMenuOpen(false)}>
                    <i className="fas fa-user-lock me-1"></i> Yönetici
                  </Link>

                  {/* Kullanıcı Profili - sosyal özellikler açıkken görünür */}
                  {(currentUser || dbUser) ? (
                    SOCIAL_ENABLED && (
                      <div className="d-flex align-items-center gap-3">
                        <NotificationBell />
                        <Link to="/profile" className="d-flex align-items-center text-dark text-decoration-none" onClick={() => setIsMenuOpen(false)}>
                          <img src={currentUser?.photoURL || dbUser?.photoURL || 'https://via.placeholder.com/40'} alt="Profile" className="rounded-circle border border-2 border-success p-1 ms-2" style={{ width: '40px', height: '40px', objectFit: 'cover' }} />
                          <span className="ms-2 fw-bold d-none d-md-inline">{currentUser?.displayName?.split(' ')[0] || dbUser?.name || dbUser?.username}</span>
                        </Link>
                      </div>
                    )
                  ) : (
                    <Link className="btn btn-primary rounded-pill px-3 fw-bold btn-sm shadow" to="/giris" onClick={() => setIsMenuOpen(false)}>
                      <i className="fas fa-user-circle me-1"></i> Oyuncu
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </nav>
        )}
        
        {SOCIAL_ENABLED && showSearch && <UserSearchModal onClose={() => setShowSearch(false)} />}

        {/* --- SAYFA YÖNLENDİRMELERİ --- */}
        <main className="app-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/market" element={<PlayerMarket />} />
            <Route path="/goals" element={<Goller />} />
            <Route path="/about" element={<Hakkimizda />} />
            <Route path="/reservation" element={<Reservation />} />
            <Route path="/squad-builder" element={<SquadBuilder />} />
            <Route path="/giris" element={<Giris />} />
            <Route path="/kayit" element={<Kayit />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin-dashboard" element={<AdminDashboard />} />
            <Route path="/superadmin" element={<SuperAdmin />} /> {/*  PATRON ROTASI */}
            <Route path="/profile" element={SOCIAL_ENABLED ? <Profile /> : <ComingSoon />} />
            <Route path="/u/:username" element={SOCIAL_ENABLED ? <PublicProfile /> : <ComingSoon />} />
            <Route path="/payment-status" element={<PaymentStatus />} />
            <Route path="/live" element={<LiveStream />} />
            <Route path="/archives" element={<MatchArchives />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;